import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const OpportunityTaskInput = () => {
  const { taskId = '' } = useParams();
  const decodedId = taskId ? atob(taskId) : taskId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'opportunityTask';

  useEffect(() => {
    if (taskId) { setIsEditing(true); fetchDetails(); }
  }, [taskId]);

  const fetchDetails = async () => {
    try {
      const response = await axios.get(API_DOMAIN + API_ROUTES['opportunityTask'] + id + '/', { headers });
      setFormData(response.data?.data ?? response.data);
    } catch (error) { console.error('Error fetching Opportunity Task details:', error); }
  };

  const fields = [{"name":"opportunity","label":"Opportunity","type":"number"},{"name":"title","label":"Title","type":"text"},{"name":"description","label":"Description","type":"textarea"},{"name":"due_date","label":"Due Date","type":"date","dateConstraint":"future"},{"name":"status","label":"Status","type":"text"}];

  return (
    <div>
      <h1>{isEditing ? 'Edit Opportunity Task' : 'Create Opportunity Task'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} />
    </div>
  );
};

export default OpportunityTaskInput;